import jwt from "jsonwebtoken";
import { checkResponse } from "../utils/checkResponse";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  SecretApiKey,
  SecretApiKeyExpires,
  _pick,
} from "../utils/setting";

const campaigns = {
  state: {
    total: 0,
    count: 0,
    listCampaign: [],
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: {
    async create(payload, rootState) {
      let myHeaders = new Headers();
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      const url = `${DomainAPI}${Channel}/api/secure/campaigns/create`;

      return await fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(
          _pick(payload, [
            "type",
            "title",
            "searchingText",
            "code",
            "banner",
            "startDate",
            "endDate",
            "enable",
            "isCommingSoon",
            "contactInfo",
            "content",
          ])
        ),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    getList(payload, rootState) {
      const _this = this;
      let myHeaders = new Headers();
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(Authorization, rootState.user.token);
      myHeaders.append(APIKey, key);
      let url = `${DomainAPI}${Channel}/api/secure/campaigns/getList`;

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(_pick(payload, ["limit", "page", "search"])),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code === 1) {
            _this.setState({
              listCampaign: res.data.list,
              total: res.data.total,
              count: res.data.count,
            });
          }
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    update(payload, rootState) {
      let myHeaders = new Headers();
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(Authorization, rootState.user.token);
      myHeaders.append(APIKey, key);
      let url = `${DomainAPI}${Channel}/api/secure/campaigns/update`;
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(
          _pick(payload, [
            "_id",
            "type",
            "title",
            "searchingText",
            "code",
            "banner",
            "startDate",
            "endDate",
            "enable",
            "isCommingSoon",
            "contactInfo",
            "content",
          ])
        ), //
      })
        .then((res) => res.json())
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    deleteById(payload, rootState) {
      let myHeaders = new Headers();
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(Authorization, rootState.user.token);
      myHeaders.append(APIKey, key);
      let url = `${DomainAPI}${Channel}/api/secure/campaigns/deleteById`;
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(_pick(payload, ["ids"])),
      })
        .then((res) => res.json())
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
  },
};

export default campaigns;
